export default __webpack_public_path__ + "static/media/addsquare.0d725514.svg";